import React, { useState } from 'react'
import { Box, Button, Modal } from '@mui/material';
import { APIDataUrl, APITokenUrl, GetOktaAuthData, GetUserId } from '../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import DeepSearchTableModal from './DeepSearchTableModal';
import { ClearIcon } from '@mui/x-date-pickers';

const DeepSearchFormModal = ({ openFormModal, setOpenFormModal, selectedValue, setOpenSelectionModal,
    organizationSearch, setOrganizationSearch, prospectSearch, setProspectSearch, handleOrgCancel, setLoading
}) => {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 480,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const loggedUser = GetOktaAuthData()

    const [openTableModal, setOpenTableModal] = useState(false)
    const [tableData, setTableData] = useState([])
    const [placeholderId, setPlaceholderId] = useState("")
    const [errorResultModal, setErrorResultModal] = useState(false);

    const handleSearchRecords = () => {
        if (selectedValue === "Organization") {
            handleAdvSearchOrganization()
        } else {
            handleAdvSearchProspect()
        }
    }

    const validateOrg = () => {
        if (!organizationSearch?.name || organizationSearch?.name?.trim() == "") {
            toast.error("Please enter organization name");
            return false
        } else if (!organizationSearch?.website && !organizationSearch?.linkedInUrl) {
            toast.error("Please enter either website or linkedin Url");
            return false
        }
        return true
    }
    const handleAdvSearchOrganization = async () => {
        if (!validateOrg()) return
        setLoading(true)

        const cleanValue = (value) => {
            return value === "" ? null : value;
        };

        const data = {
            "user_id": GetUserId(),
            "user_email": cleanValue(loggedUser?.user?.profile?.username),
            "name": cleanValue(organizationSearch?.name),
            "website": cleanValue(organizationSearch?.website),
            "industry": cleanValue(organizationSearch?.industry),
            "linkedin_url": cleanValue(organizationSearch?.linkedInUrl),
            "country": cleanValue(organizationSearch?.country),
            "address": cleanValue(organizationSearch?.address),
            "city": cleanValue(organizationSearch?.city),
            "state": cleanValue(organizationSearch?.state)
        };

        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: data,
            url: `${APIDataUrl()}/v1/data_service/deep_search/organizations`,
        };
        try {
            const response = await axios(options);
            setLoading(false)
            setPlaceholderId(response?.data?.placeholder_id)
            if (response?.data?.result?.count > 0) {
                setTableData(response?.data?.result?.matches)
                setOpenTableModal(true)
            } else {
                setErrorResultModal(true)
            }
        } catch (error) {
            setLoading(false)
            if (error?.response?.status === 404) {
                setErrorResultModal(true);
            } else {
                setErrorResultModal(true);
            }
            toast.error(error?.response?.data?.message);
        } finally {
        }
    }
    const validateProspects = () => {
        if (!prospectSearch?.firstName || prospectSearch?.firstName?.trim() == "") {
            toast.error("Please enter First Name");
            return false
        } else if (!prospectSearch?.lastName || prospectSearch?.lastName?.trim() == "") {
            toast.error("Please enter Last Name");
            return false
        } else if (!prospectSearch?.organization) {
            toast.error("Please enter Organization");
            return false
        }
        return true
    }
    const handleAdvSearchProspect = async () => {
        if (!validateProspects()) return
        setLoading(true)
        const rawData = {
            "user_id": GetUserId(),
            "user_email": loggedUser?.user?.profile?.username,
            "first_name": prospectSearch?.firstName,
            "last_name": prospectSearch?.lastName,
            "email": prospectSearch?.email,
            "job_title": prospectSearch?.jobtitle,
            "job_company_name": prospectSearch?.organization,
            "linkedIn_url": prospectSearch?.linkedInUrl
        }
        const data = Object.fromEntries(
            Object.entries(rawData).map(([key, value]) => [key, value?.trim() === "" ? null : value])
        );

        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: data,
            url: `${APIDataUrl()}/v1/data_service/deep_search/people`,
        };
        try {
            const response = await axios(options);
            setPlaceholderId(response?.data?.placeholder_id)
            setLoading(false)
            if (response?.data?.result?.count > 0) {
                setTableData(response?.data?.result?.matches)
                setOpenTableModal(true)
            } else {

                setErrorResultModal(true)
                // toast.error("No results found. Please try refining your search criteria.")
            }
        } catch (error) {
            setLoading(false)
            if (error?.response?.status === 404) {
                setErrorResultModal(true);
            } else {
                setErrorResultModal(true);
            }
            toast.error(error?.response?.data?.message);
        } finally {
        }
    }
    return (
        <>
            <Modal
                open={openFormModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="advance-search-modal">
                    <Box sx={style} style={{ overflowY: "auto", overflowX: "hidden" }}>
                        <div className="de_pad-org-adv-search">
                            <h3 className='adv-search-modal'>{selectedValue === "Organization" ? "Organization" : "Prospect"} - Deep Search<CloseIcon onClick={handleOrgCancel} /></h3>
                            <p className='sub-head-adv-search-mdl'>Can’t find an {selectedValue === "Organization" ? "Organization" : "Prospect"} you are looking for? Try our Advanced Search to see if we can locate who you are looking for.</p>
                            {selectedValue === "Organization" ?
                                <div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Organization Name <span className='red-search'>*</span>
                                        </label>
                                        <input type="text" className="input-floating-label-adv" value={organizationSearch?.name}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, name: e?.target?.value })} />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Website <span className='red-search'>*</span>
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.website}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, website: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            LinkedIn URL
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.linkedInUrl}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, linkedInUrl: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Industry
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.industry}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, industry: e?.target?.value })}
                                        />
                                    </div>

                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Country
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.country}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, country: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Address
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.address}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, address: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            City
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.city}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, city: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            State
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={organizationSearch?.state}
                                            onChange={(e) => setOrganizationSearch({ ...organizationSearch, state: e?.target?.value })}
                                        />
                                    </div>
                                </div> : <div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            First Name<span className='red-search'>*</span>
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={prospectSearch?.firstName}
                                            onChange={(e) => setProspectSearch({ ...prospectSearch, firstName: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Last name<span className='red-search'>*</span>
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={prospectSearch?.lastName}
                                            onChange={(e) => setProspectSearch({ ...prospectSearch, lastName: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Organization<span className='red-search'>*</span>
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={prospectSearch?.organization}
                                            onChange={(e) => setProspectSearch({ ...prospectSearch, organization: e?.target?.value })}
                                        />
                                    </div>

                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Email
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={prospectSearch?.email}
                                            onChange={(e) => setProspectSearch({ ...prospectSearch, email: e?.target?.value })}
                                        />
                                    </div>
                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Linkedin Url
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={prospectSearch?.linkedInUrl}
                                            onChange={(e) => setProspectSearch({ ...prospectSearch, linkedInUrl: e?.target?.value })}
                                        />
                                    </div>


                                    <div className="inner-main-object-select">
                                        <label htmlFor="" className="label-floating">
                                            Job Title
                                        </label>
                                        <input type="text" className="input-floating-label-adv"
                                            value={prospectSearch?.jobtitle}
                                            onChange={(e) => setProspectSearch({ ...prospectSearch, jobtitle: e?.target?.value })}
                                        />
                                    </div>
                                </div>}

                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className='de_cancel' onClick={() => { handleOrgCancel() }} >Cancel</Button>
                                    <Button className='de_back' onClick={() => { setOpenFormModal(false); setOpenSelectionModal(true) }}>Back</Button>
                                    <Button className='de_next' onClick={handleSearchRecords}>Search</Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div >
            </Modal >

            <Modal
                open={errorResultModal}
                onClose={() => setErrorResultModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "30%", }}>
                        <div style={{ padding: "30px 15px 30px 15px" }}>
                            <p className='cross-people-req-model'><ClearIcon onClick={() => setErrorResultModal(false)} /></p>
                            <p className='de_head'>No results found. Please try refining your search criteria..</p>
                        </div>
                    </Box>
                </div>
            </Modal>

            <DeepSearchTableModal openTableModal={openTableModal} setOpenTableModal={setOpenTableModal}
                selectedValue={selectedValue} tableData={tableData} setTableData={setTableData}
                handleOrgCancel={handleOrgCancel} setPlaceholderId={setPlaceholderId} placeholderId={placeholderId} setLoading={setLoading} />
        </>
    )
}

export default DeepSearchFormModal
